import { memo, useState } from "react"
import styled from "styled-components";
import { useAtom } from 'jotai';
import { headerCenter_currentState_Atom, HeaderCenter_State } from "./store";
import { Tooltip } from "antd";
import { elementType_Atom, showElementPanel_Atom } from "./Element/store";
import { ElementPanelUtil } from "./Element/ElementPanelUtil";
import { FiScissors } from "react-icons/fi";
import { FiBookOpen } from "react-icons/fi";
import { MdOutlineCloudUpload } from "react-icons/md";
import { PiToolbox, PiPuzzlePiece, PiGearSixBold } from "react-icons/pi";
import { HeaderCenterStyles } from './HeaderCenterStyle';
import ElementHeaderItem from "./Element/ElementHeaderItem";
import { showCreateUploadTaskPanelAtom } from "~/components/Map/panels/CreateUploadTaskPanel/store/CreateUploadTaskPanelStore";
import { show_UploadTask_UploadPanel_Atom } from "~/components/Map/panels/UploadTask_UploadPanel/store";
import { showLibraryPanelAtom } from "~/components/Map/panels/LibraryPanel/store";
import LibraryPanel from "~/components/Map/panels/LibraryPanel/LibraryPanel";
import { useTranslation } from "react-i18next";

const HeaderCenter = () => {
  const { t } = useTranslation();
  const [currentState, setCurrentState] = useAtom(headerCenter_currentState_Atom);
  const [showElementPanel, setShowElementPanel] = useAtom(showElementPanel_Atom);
  const [elementMode, setElementMode] = useAtom(elementType_Atom);
  const [showCreateUploadTaskPanel, setShowCreateUploadTaskPanel] = useAtom(show_UploadTask_UploadPanel_Atom);
  const [showLibraryPanel, setShowLibraryPanel] = useAtom(showLibraryPanelAtom);

  return (
    <>
      <UI_Wrapper>
        {/* Element */}
        <ElementHeaderItem />
        {/* End Element */}

        {/* Extract */}
        <Tooltip title="Trích xuất">
          <HeaderCenterStyles.UI_Item className={` ${currentState == HeaderCenter_State.EXTRACT ? 'active' : ''} `}
            onClick={() => {
              setCurrentState(HeaderCenter_State.EXTRACT);
            }}
          >
            <FiScissors />
          </HeaderCenterStyles.UI_Item>
        </Tooltip>
        {/* End Extract */}

        {/* Library */}
        <Tooltip title="Thư viện">
          <HeaderCenterStyles.UI_Item className={` ${currentState == HeaderCenter_State.LIBRARY ? 'active' : ''} `}
            onClick={() => {
              setCurrentState(HeaderCenter_State.LIBRARY);
              setShowLibraryPanel(true);
            }}
          >
            <FiBookOpen />
          </HeaderCenterStyles.UI_Item>
        </Tooltip>
        {/* End Library */}

        {/* Upload anything */}
        <Tooltip title="Nhập tệp GIS">
          <HeaderCenterStyles.UI_Item className={` ${currentState == HeaderCenter_State.UPLOAD_ANYTHING ? 'active' : ''} `}
            onClick={() => {
              setCurrentState(HeaderCenter_State.UPLOAD_ANYTHING);
              setShowCreateUploadTaskPanel(true);
            }}
          >
            <MdOutlineCloudUpload />
          </HeaderCenterStyles.UI_Item>
        </Tooltip>
        {/* End Upload anything */}

        {/* Transform */}

        <Tooltip title="Công cụ chuyển đổi">
          <HeaderCenterStyles.UI_Item className={` ${currentState == HeaderCenter_State.TRANSFORM ? 'active' : ''} `}
            onClick={() => {
              setCurrentState(HeaderCenter_State.TRANSFORM);
            }}
          >
            <PiToolbox />
          </HeaderCenterStyles.UI_Item>
        </Tooltip>
        {/* End Transform */}

        {/* Component */}
        <Tooltip title="Phần mở rộng">
          <HeaderCenterStyles.UI_Item className={` ${currentState == HeaderCenter_State.COMPONENT ? 'active' : ''} `}
            onClick={() => {
              setCurrentState(HeaderCenter_State.COMPONENT);
            }}>
            <PiPuzzlePiece />
          </HeaderCenterStyles.UI_Item>
        </Tooltip>
        {/* End Component */}

        {/* Settings */}
        <Tooltip title={t('map_settings_title')}>
          <HeaderCenterStyles.UI_Item
            className={`header-settings-btn ${currentState == HeaderCenter_State.SETTINGS ? 'active' : ''}`}
            onClick={() => {
              setCurrentState(currentState === HeaderCenter_State.SETTINGS ? HeaderCenter_State.NONE : HeaderCenter_State.SETTINGS);
            }}
          >
            <PiGearSixBold />
          </HeaderCenterStyles.UI_Item>
        </Tooltip>
        {/* End Settings */}
      </UI_Wrapper>
      {/* Library Panel */}
      {showLibraryPanel && <LibraryPanel />}
    </>
  )
}

export default memo(HeaderCenter);

const UI_Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  background: rgba(248, 250, 252, 0.85);
  padding: 3px 6px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
  backdrop-filter: blur(8px);
`;